export const isSuperAdmin = (user) => {
  return !user?.ofCompany ? true : false;
};

export const getFilteredKeys = (modelInstance) => {
  return Object.keys(modelInstance).filter(
    (key) =>
      key !== "_id" && // Exclude `_id`
      !Array.isArray(modelInstance[key]) && // Exclude arrays
      typeof modelInstance[key] !== "object" // Exclude objects
  );
};

export const getDateRange = () => {
  const today = new Date();

  // Calculate the date 7 days ago
  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(today.getDate() - 7);

  // Return the date range as formatted strings
  return {
    startDate: sevenDaysAgo.toISOString().split("T")[0],
    endDate: today.toISOString().split("T")[0],
  };
};

export const capitalizeWord = (word) => {
  if (!word || typeof word !== "string") return "";
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

export const incrementDateByOne = (dateString) => {
  // Parse the input date string (YYYY-MM-DD)
  const [year, month, day] = dateString.split("-").map(Number);

  // Create a Date object
  const date = new Date(year, month - 1, day); // Months are zero-based in JavaScript

  // Increment the date by one day
  date.setDate(date.getDate() + 1);

  // Format the new date back to YYYY-MM-DD
  const newYear = date.getFullYear();
  const newMonth = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const newDay = String(date.getDate()).padStart(2, "0");

  return `${newYear}-${newMonth}-${newDay}`;
};

export const generateCompanyCode = (companyName) => {
  if (!companyName || companyName.trim().length < 2) {
    throw new Error("Company name must have at least 2 characters.");
  }

  // Trim whitespace and ensure the name is valid
  const trimmedName = companyName.trim();
  const firstChar = trimmedName[0].toUpperCase(); // First character
  const lastTwoChars = trimmedName.slice(-2).toUpperCase(); // Last two characters
  const randomDigits = Math.floor(100 + Math.random() * 900); // Random 3 digits

  return `${firstChar}${lastTwoChars}${randomDigits}`;
};

export const splitByUppercase = (text) => {
  if (!text) return "";
  return text.replace(/([A-Z])/g, " $1").trim();
};

export const convertToUTCString = (date, showTime = true) => {
  if (!date) return ""; // Handle empty or undefined dates

  const utcDate = new Date(date);

  // Extract components
  const day = utcDate.toUTCString().split(",")[0];
  const dateNumber = utcDate.getUTCDate();
  const month = utcDate.toUTCString().split(" ")[2];
  const year = utcDate.getUTCFullYear();

  if (!showTime) {
    // Return only the date if `showTime` is false
    return `${day}, ${dateNumber} ${month} ${year}`;
  }

  let hours = utcDate.getUTCHours();
  const minutes = utcDate.getUTCMinutes().toString().padStart(2, "0");
  const seconds = utcDate.getUTCSeconds().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  // Convert hours to 12-hour format
  hours = hours % 12 || 12;

  // Format final string with time
  return `${day}, ${dateNumber} ${month} ${year} ${hours}:${minutes}:${seconds} ${ampm}`;
};

export const convertSecondsToHMS = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  let result = "";
  if (hours > 0) result += `${hours}h `;
  if (minutes > 0) result += `${minutes}m `;
  if (remainingSeconds > 0) result += `${remainingSeconds}s`;

  return result.trim();
};
